/* Cart totals and discounts are rendered by Shopify, never simulated here. */
document.addEventListener('click',event=>{
 const link=event.target.closest('a[href*="#shop-"]');
 if(!link)return;
 const target=document.getElementById(new URL(link.href).hash.slice(1));
 if(target){event.preventDefault();target.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});}
});
